import { Container, createTheme } from '@mantine/core';
import cx from 'clsx';
import classes from './theme/theme.module.css';

const theme = createTheme({
  colors: {
    'pq-red': ['#B31E3B', '#B31E3B', '#B31E3B', '#B31E3B', '#B31E3B', '#B31E3B', '#B31E3B', '#B31E3B', '#B31E3B', '#B31E3B'],
    'pq-dark-red': ['#910933', '#910933', '#910933', '#910933', '#910933', '#910933', '#910933', '#910933', '#910933', '#910933'],
    'pq-gray': ['#858585', '#858585', '#858585', '#858585', '#858585', '#858585', '#858585', '#858585', '#858585', '#858585'],
    'pq-light-gray': ['#EEEEEE', '#EEEEEE', '#EEEEEE', '#EEEEEE', '#EEEEEE', '#EEEEEE', '#EEEEEE', '#EEEEEE', '#EEEEEE', '#EEEEEE'],
    'pq-med-gray': ['#B3B3B3', '#B3B3B3', '#B3B3B3', '#B3B3B3', '#B3B3B3', '#B3B3B3', '#B3B3B3', '#B3B3B3', '#B3B3B3', '#B3B3B3'],
    'pq-dark-gray': ['#4D4D4D', '#4D4D4D', '#4D4D4D', '#4D4D4D', '#4D4D4D', '#4D4D4D', '#4D4D4D', '#4D4D4D', '#4D4D4D', '#4D4D4D'],
    'gray': ['#E8E8E8', '#E8E8E8', '#E8E8E8', '#B3B3B3', '#4D4D4D', '#4D4D4D', '#4D4D4D', '#4D4D4D', '#4D4D4D', '#4D4D4D'],
  },
  fontFamily: 'Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji',
  fontFamilyMonospace: 'SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;',
  headings: {
    fontFamily: 'Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji',
    sizes: {
      h1: { fontSize: '2rem', fontWeight: '900' },
      h2: { fontSize: '1.75rem', fontWeight: '900' },
      h3: { fontSize: '1.5rem', fontWeight: '900' },
      h4: { fontSize: '1.25rem', fontWeight: '900' },
      h5: { fontSize: '1.15rem', fontWeight: '900' },
      h6: { fontSize: '1rem', fontWeight: '900' },
    }
  },
  fontSizes: {
    xs: '16px',
    sm: '16px',
    md: '16px',
    lg: '18px',
    xl: '20px',
  },
  primaryColor: 'pq-red',
  
  components: {
    Container: Container.extend({
      classNames: (_, { size }) => ({
        root: cx({ [classes.responsiveContainer]: size === 'responsive' }),
      }),
    }),
  }
});

export default theme;